import { Component, OnInit, Input, ViewChild, ElementRef, QueryList, OnChanges,
   SimpleChanges, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { process, State } from '@progress/kendo-data-query';
import { sampleLots, SessionService, RequestServiceModelView, BCASearch, GasRequestStatusEnum, RequestStatusEnum} from '@app/base/core';
import { BuilderService } from '@app/modules/builder/base/services';
import { GridDataResult, DataStateChangeEvent, SelectAllCheckboxState, PageChangeEvent,
  SelectableSettings, RowClassArgs } from '@progress/kendo-angular-grid';
import { LookupsService, ConstantsService, RequestServiceModel, LandingSiteContactDetails, AccountService } from '@app/base/core';
import { LotDetails } from '../../request-lot/LotDetails';
import { SocoHttpService } from '@app/soco/http';
import { triggerFormValidation, phoneNumber } from '@app/shared/functions';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ServiceActivateRequestComponent } from '../../request/service.request/service.activate.request/service.activate.request.component';

import moment from 'moment';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'service-request',
  templateUrl: './service.request.component.html',
  styleUrls: ['./service.request.component.css']
})
export class ServiceRequestComponent implements OnInit, OnChanges, OnDestroy {
  // cssProperty: string;
  defaultSkip = 0;
  public skip = 0;
  public selectedLots = 0;
  public killsubscribe: boolean;
  router: Router;
  today = new Date();
  one_day = 1000 * 60 * 60 * 24;
  todayDate;
  public checkedLots: LotDetails[];
  public result: ExcelExportData;
  public state: State = {
    skip: this.defaultSkip,
    take: 5,

    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public loading = false;
  public lotId: any[];
  public lotOriginal: number[] = [];
  public idList: number[] = [];
  public lotsData: RequestServiceModelView[] = [];
  public lotdetails: RequestServiceModel[] = [];
  public GasRequestStatus = GasRequestStatusEnum;
  // Request service Model for the http post request
  model: RequestServiceModel = new RequestServiceModel();
  public rqstServiceLots: RequestServiceModel[] = new Array();
  public pageSizes = true;
  public previousNext = true;
  public buttonCount = 5;
  public bcaStatuses = [];
  public flag = 0;
  public navFlag;
  documentInput: any = {};
  public bcaData: any = [];
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  builderHomeForm: FormGroup;
  public bcaStatus;
  landingSiteContactDetails: LandingSiteContactDetails = new LandingSiteContactDetails();
  // kendo Grid variables //
  public mySelection: number[] = [];
  // public routeSubscription: any;
  // public subscription: Subscription;
  public builderDetailsSubscription: Subscription;
  public getLotDetailsSubscription: Subscription;
  public selectableSettings: SelectableSettings;
  public selectAllState: SelectAllCheckboxState = 'unchecked';
  public selecteditem: any[];
  public stateCd: string;
  public requestType: string;
  public pageSize = 5;
  public items: any[] = sampleLots;
  public bcadata: any;
  lotNO: number;
  lstWorkRequests: any = [];
  lstUpdateBuildingIds: any = [];
  lstAddBuildingIds: any = [];
  lstGISBuildingIds: any = [];
  gasRequestDetails: any;
  gasRequestViewDetails: any;

  public isServiceRequested;
  date1 = new Date('04/09/2018');
  date2 = new Date('04/09/2019');
  public bcaSearch: BCASearch = {
    builderId: [],
    projectName: '',
    projectAddress: '',
    bcaStatus: '',
    subsidaryId: '',
    subsidarycompanyName: '',
    startDate: this.date1,
    endDate: this.date2,
    reqId: '',
    bcaStatusValue: ''
  };
  wRNo: number;
  public GridId: number;
  public grid: any;
  public paramId;
  public marketerDocCount = 0;
  public projectNumber: any;
  public projectName: any;
  public grStatus: any;
  public grTypeCd: any;
  public parentList: any = [];
  public rowValue;
  public gridData3: GridDataResult;
  // Kendo Grid //

  @ViewChild(ServiceActivateRequestComponent, { static: false }) serviceActivateRequestComponent: ServiceActivateRequestComponent;
  @Input()
  gridId: number;
  @ViewChild('myAnchor', {static: false}) myAnchors: QueryList<ElementRef>;
  public builderid: string;
  public builderidArray;

  ngOnChanges(changes: SimpleChanges): void {
    this.rowValue = changes.gridId.currentValue;
    this.gridData3.data = [];
    this.gridData3.total = 0;
    this.lotsData = [];
    this.getServiceGridLotData();
  }
  // Meter Activate/Deactivate
  showMeterActivate(lotNumber: any) {
    this.lotId = [];
    this.lotId.push(this.lotsData.filter(a => a.lotNumber === lotNumber)[0]);
  }
  // Set date format for date control
  updateDateRange(event: any, controlName: string) {
    this.builderHomeForm.controls[controlName].setValue(
      moment(event.start).format('MM/dd/yyyy'),
      { emitEvent: true }
    );
  }
   // Bind data to grid on data state change
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData3 = (process(this.lotsData, this.state));
  }
  constructor(
    public lookupSvc: LookupsService,
    public constantsSvc: ConstantsService,
    public builderSvc: BuilderService,
    public sessionSvc: SessionService,
    public accountSvc: AccountService,
    public socoHttp: SocoHttpService,
    private route: ActivatedRoute,
    _router: Router
  ) {
    this.allData = this.allData.bind(this);
    this.router = _router;
  }
  // Unsubscribe subscriptions
  ngOnDestroy() {
    if ($('#lot_details').is(':visible')) {
      $('#lot_details').modal('hide');
    }
    if ($('#modal_request_service').is(':visible')) {
      $('#modal_request_service').modal('hide');
    }
    if ($('#modal_activate_deactivate').is(':visible')) {
      $('#modal_activate_deactivate').modal('hide');
    }
    this.killsubscribe = false;
    if (this.builderDetailsSubscription) {
      this.builderDetailsSubscription.unsubscribe();
    }
    if (this.getLotDetailsSubscription) {
      this.getLotDetailsSubscription.unsubscribe();
    }
  }
  ngOnInit() {
    this.killsubscribe = true;
    $('#lot_details').on('shown.bs.modal', function(event) {
      // not setting focus to submit button
      $('#btnClose').focus();
  });
    $('#modal_request_service').on('shown.bs.modal', function(event) {
      // not setting focus to submit button
      $('#btnClose').focus();
  });
$('#modal_activate_deactivate').on('shown.bs.modal', function(event) {
  // not setting focus to submit button
  $('#btnClose').focus();
});
    // To get gas request Id from route params
    this.todayDate = this.today.getTime();
    this.rowValue = this.route.snapshot.parent.params['id'];
    this.grid = this.route.snapshot.parent.params['id'];
    this.lookupSvc.commonLookupsLoaded$.subscribe(isloaded => {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
      if (isloaded) {
        this.builderSvc.GetLotDetails(this.route.snapshot.parent.params['id']).subscribe(res2 => {
          if (res2) {
         this.sessionSvc.builderData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
          if (success) {
            // To get Project documents of logged in builder
            this.documentInput.Builder = success.CompanyName;
            this.documentInput.Folder = this.constantsSvc.builderMarketerAgreement;
            this.builderid = success.BuilderId[0];
            this.builderidArray = success.BuilderId;
            if ( res2.data.length > 0 ) {
              this.stateCd = res2.data[0].stateCd;
            if ((success.CompanyName !== undefined) && res2.data[0].stateCd === 'GA') {
              this.builderSvc.findFilesCountByMetadata(this.documentInput).subscribe(result => {
               this.marketerDocCount = result;
           });
         }
        }
           this.sessionSvc.BcaData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
              if (Array.isArray(success) && success.length > 0) {
                this.sessionSvc.GridData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
                  // TO get project details
                  this.projectNumber = success.projectNumber;
                  this.projectName = success.projectName;
                  this.bcaStatus = success.bcaStatus;
                  this.grStatus = success.grStatus;
                  this.grTypeCd = success.requestTypeCd;
                  this.isServiceRequested = success.isServiceRequested;
                  const stateCd: string = success.stateCd;
                  const requestType: string = success.requestTypeCd;
  if (requestType === 'COMM' || requestType === 'AD-LOAD-COMM' || requestType === 'CONV-COMM' ||
  requestType === 'INDUSTRIAL-ALD' || requestType === 'INDUSTRIAL') {
    this.requestType = 'Commercial';
  } else if (requestType === 'SCATT' || requestType === 'SUBD' || requestType === 'ADD-LOAD-RES'
   || requestType === 'CONV-RES' || requestType === 'MULTI_FAMILY') {
    this.requestType = 'Residential';
  }
  if (stateCd !== null) {
    this.lookupSvc.loadBcaLookups(this.requestType, stateCd);
  } else {
      this.lookupSvc.loadBcaLookups(this.requestType, success.stateCd);
  }
                });

              } else {
                for (let i = 0; i < this.builderidArray.length; i++) {
                  this.bcaSearch.builderId.push(this.builderidArray[i]);
                }
                this.bcaSearch.reqId = this.rowValue;
                this.builderDetailsSubscription = this.builderSvc.getBuilderBCADetails(this.bcaSearch).subscribe(result => {
                  this.bcaData = result;
                  if (result.data[0].bcaId !== undefined) {
                    this.projectNumber = result.data[0].bcaId;
                  }
                  this.bcaStatus = result.data[0].grStatus;
                  this.grStatus = result.data[0].grStatus;
                  this.projectName = result.data[0].projectName;
                  this.grTypeCd = result.data[0].gasRqstTpCd;
                  this.isServiceRequested = result.data[0].isAllServiceRequested;
                  const stateCd: string = result.data[0].stateCd;
                  const requestType: string = result.data[0].gasRqstTpCd;
  if (requestType === 'COMM' || requestType === 'AD-LOAD-COMM' || requestType === 'CONV-COMM' ||
  requestType === 'INDUSTRIAL-ALD' || requestType === 'INDUSTRIAL') {
    this.requestType = 'Commercial';
  } else if (requestType === 'SCATT' || requestType === 'SUBD' || requestType === 'ADD-LOAD-RES'
   || requestType === 'CONV-RES' || requestType === 'MULTI_FAMILY') {
    this.requestType = 'Residential';
  }
  if (stateCd !== null) {
    this.lookupSvc.loadBcaLookups(this.requestType, stateCd);
  } else {
    this.lookupSvc.loadBcaLookups(this.requestType, this.sessionSvc.activeLdc.code);
  }
                });
              }
            });
          }
        });
      }
    });
        // Invoking API to get the lotDetails using session service
        if (this.lotsData.length === 0) {
         this.getServiceGridLotData();

      }
    }
  });
    this.builderHomeForm = new FormGroup({
      plannedDate: new FormControl(this.landingSiteContactDetails.plannedDate),
      deliveryPressure: new FormControl(
        this.landingSiteContactDetails.directionPrefix,
        Validators.required
      ),
      firstName: new FormControl(
        this.landingSiteContactDetails.firstName,
        Validators.required
      ),
      lastName: new FormControl(
        this.landingSiteContactDetails.lastName,
        Validators.required
      ),
      email: new FormControl(this.landingSiteContactDetails.email, [
        Validators.required,
        Validators.pattern(this.constantsSvc.emailPattern)
      ]),
      contactNumber: new FormControl(
        this.landingSiteContactDetails.contactNumber,
        [
          Validators.required,
          Validators.pattern(this.constantsSvc.phoneNumberPattern)
        ]
      ),
      contactNumberExtension: new FormControl(
        this.landingSiteContactDetails.contactNumberExtension,
        Validators.pattern(this.constantsSvc.phoneNumberExtensionPattern)
      ),
      other: new FormControl('')
    });
  }
  // get service grid Lot data
  getServiceGridLotData() {
    const wrTypeCodes = ['CINBE', 'RNBE', 'SRNBE', 'MLTFM'];
    this.getLotDetailsSubscription = this.builderSvc.GetLotDetails(this.rowValue).subscribe(result => {
      this.gridData3 = {
        data: [],
        total: 0
      };
      for (let i = 0; i < result.data.length; i++) {
        if (!wrTypeCodes.includes(result.data[i]['wrTypeCD'])) {
        result.data[i]['address'] = this.getLotServAddress(result.data[i]);
        const resultDate = result.data[i].constructionCompleteDate;
        if (resultDate !== null) {
          const resultday = new Date(resultDate);
          const resultdayTime = resultday.getTime();
          const dateDiff = Math.round((this.todayDate - resultdayTime) / this.one_day);
          if (dateDiff < 90) {
            if (result.data[i]['wrTypeCD'] != null) {
              const wrCd = {
                oldwrCd: result.data[i]['wrTypeCD']
              };
              Object.assign(result.data[i], wrCd);
              result.data[i]['oldwrCd'] = (this.lookupSvc.WorkRequestType.find(x => x.id === result.data[i]['oldwrCd'])).itemName;
            }
            if (result.data[i]['lotStatus'] != null) {
              result.data[i]['lotStatus'] = (this.lookupSvc.LotStatusTypes.find(x => x.id === result.data[i]['lotStatus'])).itemName;
            }
            this.lotsData.push(result.data[i]);
          }
        } else {
          if (result.data[i]['wrTypeCD'] != null) {
            const wrCd = {
              oldwrCd: result.data[i]['wrTypeCD']
            };
            Object.assign(result.data[i], wrCd);
            result.data[i]['oldwrCd'] = (this.lookupSvc.WorkRequestType.find(x => x.id === result.data[i]['oldwrCd'])).itemName;
          }
          if (result.data[i]['lotStatus'] != null) {
            result.data[i]['lotStatus'] = (this.lookupSvc.LotStatusTypes.find(x => x.id === result.data[i]['lotStatus'])).itemName;
          }
          this.lotsData.push(result.data[i]);
        }
        }
      }
      // Binding data to Grid
      this.gridData3 = (process(this.lotsData, this.state));
      this.getDuplicates();
      this.getParentId();
  });
  }

  getParentId() {
    this.gridData3.data.forEach(element => {
      this.builderSvc.getBuilderMapping(element.builderId).subscribe(result => {
        if (result.data !== null) {
           this.parentList.push(result.data);
        }
      });
    });
  }
  // get duplicates to check allocated builder
  getDuplicates() {

    this.builderSvc.GetLots(this.grid, this.builderid).subscribe(result => {
      this.lotdetails = result.data;
      this.checkAllocated();
    },
    (error) => {
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.gasDetailsFailSwal, this.constantsSvc.errorSwal);
    });
  }

  getBuildingId() {
    this.lstWorkRequests = [];
    this.lstUpdateBuildingIds = [];
    this.lstAddBuildingIds = [];
    this.lstGISBuildingIds = [];

    const bcaId = this.projectNumber;
    if (!bcaId || bcaId === '') {
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.noBcaSwal, this.constantsSvc.errorSwal);
    } else {
      this.builderSvc.getGasRequestByBcaId(Number(bcaId)).subscribe(result => {
       if (result.status && result.data) {
          this.gasRequestDetails = result.data;
          this.CheckRequestStatus(bcaId);
           }
      }, error => {
        this.CheckRequestStatus(bcaId);
      });
    }
  }


CheckRequestStatus(bcaId)  {
    this.builderSvc.GetBCAStatusFromView(bcaId).subscribe(result => {
      this.gasRequestViewDetails = result.data;
      if (result.status && result.data.length !== 0) {
        if (result.data[0].grStatus === RequestStatusEnum.ContractReceived || result.data[0].grStatus === RequestStatusEnum.Permit ||
          result.data[0].grStatus === RequestStatusEnum.Payment || result.data[0].grStatus === RequestStatusEnum.WRCreated ||
          result.data[0].grStatus === RequestStatusEnum.Completed) {
          this.getBuildingIdsHttpCall(bcaId);
        } else {
          swal('', this.constantsSvc.bcaNoCntrctRcvd, this.constantsSvc.infoSwal);
        }
      } else {
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.bcaNoCntrctRcvd, this.constantsSvc.errorSwal);
      }
    }, error => {
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.errorBcaStatusFetch, this.constantsSvc.errorSwal);
    });

  }


getBuildingIdsHttpCall(bcaId: any) {
    this.socoHttp.showPleaseWait(this.constantsSvc.processingMsg, this.constantsSvc.containerIdMsg);
    let ldc = '';
    if (this.gasRequestDetails === null || this.gasRequestDetails === undefined) {
      ldc = this.gasRequestViewDetails[0].companyCd;
    } else {
      ldc = this.gasRequestDetails.companyCd;
    }
    const model = { bcaId: bcaId, ldc: ldc, stateCd: '' };
    this.builderSvc.getBuildingIdList(model).subscribe(result => {
      if (result.status) {
        this.validateAndPostBuildingIds(this.gasRequestDetails, result.data, bcaId);

      } else {
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.errorWhenBIdsFetch, this.constantsSvc.errorSwal);
        this.socoHttp.hidePleaseWait(this.constantsSvc.containerIdMsg);
      }
    }, error => {
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.errorWhenBIdsFetch, this.constantsSvc.errorSwal);
      this.socoHttp.hidePleaseWait(this.constantsSvc.containerIdMsg);
    });
  }


validateAndPostBuildingIds(gasRequest: any, buildingIds: any, bcaId: any) {
    this.builderSvc.getWorkRequestByBcaId(Number(bcaId)).subscribe(async result => {
      if (result.status) {
        this.lstWorkRequests = result.data;
        const buildingIdList =  this.transformBuildingPoints(buildingIds, bcaId);
        // case of only 1 building point received from GIS
        if (buildingIds.value.length === 1) {
          buildingIdList.forEach( model => {
            // If lot number is null and building id is not null and building id do not exist in our database,
            // then add it to array to process with Lot Number as 1. Copy the BCA Address
            if (model.lotNumber === null || model.lotNumber === this.constantsSvc.noneText || model.lotNumber === '') {
              if (model.buildingId !== this.constantsSvc.noneText && model.buildingId !== null) {
                const lot = this.lstWorkRequests.find(x => x.buildingId === model.buildingId);
                if (!lot) {
                  model.lotNumber = '1';
                  // need to add BCA address values
                    this.lstGISBuildingIds.push(model);
                }
              }
            } else {
              // If lot number is not null and building Id is present then add it to array to process
              if (model.buildingId !== this.constantsSvc.noneText && model.buildingId !== null) {
                this.lstGISBuildingIds.push(model);
              }
            }
          });
          if ((this.gasRequestDetails) ? this.gasRequestDetails.builderId : false) {
            this.processBuildingIds(bcaId, 'AA');
          } else {
            this.processBuildingIds(bcaId, 'SR');
          }
        } else {
          // case of more than 1 building point received from GIS
          buildingIdList.forEach(model => {
            // If lot number is not null and building id is not null, then add it to array to process
            if ((((model.lotNumber !== null && model.lotNumber !== this.constantsSvc.noneText && model.lotNumber !== '') ||
                (model.buildingAddress !== null && model.buildingAddress.street_number !== null &&
                   model.buildingAddress.street_number !== this.constantsSvc.noneText && model.buildingAddress.street_number !== '')) &&
                (model.buildingId !== this.constantsSvc.noneText && model.buildingId !== null)) &&
                // Logic to ingore Building Point if Street_Name, City, State, Zip is empty/null
                ((model.buildingAddress !== null && model.buildingAddress.zip !== null && model.buildingAddress.zip !==
                   this.constantsSvc.noneText && model.buildingAddress.zip !== '') &&
                  (model.buildingAddress.street_name !== null && model.buildingAddress.street_name.trim() !== '') &&
                  (model.buildingAddress.city !== null && model.buildingAddress.city !== this.constantsSvc.noneText
                    && model.buildingAddress.city !== '') &&
                  (model.buildingAddress.state !== null && model.buildingAddress.state !== this.constantsSvc.noneText
                    && model.buildingAddress.state !== '')
                )) {
              if (model.lotNumber === null || model.lotNumber === this.constantsSvc.noneText || model.lotNumber === '') {
                model.lotNumber = null;
              }
              if (model.buildingAddress.street_number === null || model.buildingAddress.street_number === this.constantsSvc.noneText
                || model.buildingAddress.street_number === '') {
                model.buildingAddress.street_number = null;
              }
              if (model.buildingAddress.unitnumber === null || model.buildingAddress.unitnumber === this.constantsSvc.noneText
                || model.buildingAddress.unitnumber === '') {
                model.buildingAddress.unitnumber = null;
              }
              this.lstGISBuildingIds.push(model);
            }
          });
          // Logic to check if more than 1 building point has same lotNumber and StreetNumber combination
          for (let index = 0; index < this.lstGISBuildingIds.length; index++) {
            const element = this.lstGISBuildingIds[index];
            let counter = 0;
            for (let i = 0; i < this.lstGISBuildingIds.length; i++) {
              const buildingId = this.lstGISBuildingIds[i];
              if (buildingId.buildingId === element.buildingId || (buildingId.lotNumber === element.lotNumber &&
                buildingId.buildingAddress.street_number === element.buildingAddress.street_number &&
                buildingId.buildingAddress.street_name === element.buildingAddress.street_name &&
                buildingId.buildingAddress.unitnumber === element.buildingAddress.unitnumber)) {
                  counter++;
              }
            }
            if (counter > 1) {
              this.lstGISBuildingIds.splice(index, 1);
              index--;
            }
          }
          if ((this.gasRequestDetails) ? this.gasRequestDetails.builderId : false) {
            this.processBuildingIds(bcaId, 'AA');
          } else {
            this.processBuildingIds(bcaId, 'SR');
          }
        }
      }
    },
    (error) => {
            swal(this.constantsSvc.errorSwal1, this.constantsSvc.workRequestByBcaFail, this.constantsSvc.errorSwal);
      }
   );
  }


transformBuildingPoints(buildingIds: any, bcaId: any) {
    const transformedGISBuildingIds = [];
    let buildingIdExists = false;
    buildingIds.value.forEach(element => {
      element[2] = element[2] ? element[2].toString().replace(/': b'/g, '\': \'') : element[2];
      const buildingId = element[0].split(':')[1].trim();
      this.builderSvc.VerifyBuilingPointExists(buildingId).subscribe(async result => {
      buildingIdExists = this.gasRequestDetails ? false : result.data;
    });

      const address = element[2] ? JSON.parse((element[2].substring(element[2].indexOf(':') + 1)).replace(/'/g, '\"')) : null;
      const model = {
        buildingId: element[0].split(':')[1].trim(),
        lotNumber: element[1].split(':')[1].trim(),
        buildingAddress: address,
        bcaId: bcaId,
        givenName: this.accountSvc.account.user.givenName,
        userName: this.accountSvc.account.user.username
      };

      if (model.buildingAddress) {
        const localDistrict = this.lookupSvc.localDistrict.find(x =>
          x.itemName.trim().toUpperCase().includes(model.buildingAddress.localDistrict.trim().toUpperCase()));
        const county = this.lookupSvc.counties.find(x =>
          x.itemName.trim().toUpperCase().includes(model.buildingAddress.county.trim().toUpperCase()));

        model.buildingAddress.localDistrict = localDistrict ? localDistrict.id : '-1';
        model.buildingAddress.county = county ? county.id : '-1';
      }
      if (!buildingIdExists) {
      transformedGISBuildingIds.push(model);
    }
    });
    return transformedGISBuildingIds;
  }

processBuildingIds(bcaId: any, status: string) {
    // code to make update and add list of GIS building Ids fetched
    this.lstGISBuildingIds.forEach(element => {
      const req = this.lstWorkRequests.find(r => r.buildingId === element.buildingId);
      if (req) {
        if (req.wrNo === null) {
          this.lstUpdateBuildingIds.push(element);
        }
      } else {
        const req1 = this.lstWorkRequests.find(r => r.lotNumber === element.lotNumber &&
          (element.buildingAddress ? ((r.streetNo ? r.streetNo.toString() : '0') === (element.buildingAddress.street_number ?
          element.buildingAddress.street_number : '0')) : true) &&
          (element.buildingAddress ?
            ((r.streetName ? r.streetName.trim().toLowerCase() : null)
              === (element.buildingAddress.street_name ? element.buildingAddress.street_name.trim().toLowerCase() : null)) : true) &&
          (element.buildingAddress ? ((r.unitNo ? r.unitNo : null) ===
            (element.buildingAddress.unitnumber ? element.buildingAddress.unitnumber : null)) : true));
        if (req1) {
          if (req1.wrNo === null) {
            this.lstUpdateBuildingIds.push(element);
          }
        } else {
            this.lstAddBuildingIds.push(element);
          }
      }
    });

    if (this.lstGISBuildingIds.length > 0) {
      if (this.lstUpdateBuildingIds.length > 0 && this.lstAddBuildingIds.length > 0) {
        this.builderSvc.bulkUpdateBuildingIds(this.lstUpdateBuildingIds).subscribe(result => {
          if (result.status) {
            this.builderSvc.bulkAddBuildingIds(this.lstAddBuildingIds, status).subscribe(resultAdd => {
              if (resultAdd.status) {
                swal(this.constantsSvc.successSwal1, this.lstAddBuildingIds.length + this.constantsSvc.bIdsAddedAndMsg +
                      this.lstUpdateBuildingIds.length + this.constantsSvc.bIdsUpdatedMsg + bcaId, this.constantsSvc.successSwal);
                this.refreshGrid('ref');
              }
            },
            (error) => {
              swal(this.constantsSvc.errorSwal1, this.constantsSvc.requestAddBuildingId, this.constantsSvc.errorSwal);
            });
          }
        },
        (error) => {
          swal(this.constantsSvc.errorSwal1, this.constantsSvc.requestUpdateBuildingId, this.constantsSvc.errorSwal);
        });
      } else if (this.lstUpdateBuildingIds.length > 0) {
        this.builderSvc.bulkUpdateBuildingIds(this.lstUpdateBuildingIds).subscribe(result => {
          if (result.status) {
            swal(this.lstUpdateBuildingIds.length + this.constantsSvc.bIdsUpdatedMsg + bcaId, this.constantsSvc.successSwal);
            this.refreshGrid('ref');
          }
        },
        (error) => {
          swal(this.constantsSvc.errorSwal1, this.constantsSvc.requestUpdateBuildingId, this.constantsSvc.errorSwal);
        });
      } else if (this.lstAddBuildingIds.length > 0) {
        this.builderSvc.bulkAddBuildingIds(this.lstAddBuildingIds, status).subscribe(result => {
          if (result.status) {
            swal(this.constantsSvc.successSwal1, this.lstAddBuildingIds.length + this.constantsSvc.bIdsAddedMsg + bcaId,
              this.constantsSvc.successSwal);
              this.refreshGrid('ref');
          }
        },
        (error) => {
          swal(this.constantsSvc.errorSwal1, this.constantsSvc.requestAddBuildingId, this.constantsSvc.errorSwal);
        });
      }
    } else {
      swal(this.constantsSvc.noBIdsAvailable + bcaId);
    }
  }

  // Disabling selection of  disabled rows on select All functionality
  public onSelectAllChange(checkedState: SelectAllCheckboxState) {
    if (checkedState === 'checked') {
      this.mySelection = this.lotsData
        .filter(item => item.originalBd === this.builderid && item.lotStatus === 'Allocation Approved')
        .map((item) => item.lotNumber);
      this.selectAllState = 'checked';
    } else {
      this.mySelection = [];
      this.selectAllState = 'unchecked';
    }
  }
  // Disabled function in Kendo Grid on selected checkbox
  public onSelectedKeysChange(e) {
    const len = this.mySelection.length;
    const enabledLen = this.gridData3.data.filter(item => item.originalBd === this.builderid &&
      item.lotStatus === 'Allocation Approved').length;
    if (len === 0) {
      this.selectAllState = 'unchecked';
    } else if (len > 0 && len < enabledLen) {
      this.selectAllState = 'indeterminate';
    } else {
      this.selectAllState = 'checked';
    }
  }
  public selectRow(dataItem: any, event: any) {
    if (event.target.checked) {
      const index = this.lotsData.findIndex(x => x.lotNumber === dataItem.lotNumber);
      if (index !== -1) {
        this.selecteditem.push(this.lotsData[index]);
      }
    } else if (!event.target.checked) {
      const index = this.selecteditem.findIndex(x => x.lotNumber === dataItem.lotNumber);
      this.selecteditem.splice(index, 1);
    }
  }

  public selectionChange(event: any) {
    if (event.selectedRows[0]) {
      this.selecteditem.push(event.selectedRows[0].dataItem);
    } else if (event.deselectedRows[0]) {
      this.selecteditem.splice(event.deselectedRows[0].index, 1);
    }
  }
  // isDisabled functionality for the Kendo Grid row based on lotstatus
  public isDisabled = (dataItem: any) => {
    if (dataItem['lotStatus'] === 'Allocation Approved' && dataItem['originalBd'] === this.builderid) {
      return false;
    } else {
      return true; }
    }
  // Kendo Grid event to load data
  private loadItems(): void {

    this.gridData3 = {
      data: this.lotsData.slice(this.skip, this.skip + this.pageSize),
      total: this.lotsData.length
    };
    this.socoHttp.hidePleaseWait('ContainerAwaiter1');
  }
  // Check allocated builder id for row to enable
   checkAllocated() {
    let rs: any;
    for (rs in this.lotdetails) {
      if (!this.lotOriginal.find(x => x === this.lotdetails[rs].lotNumber)) {
        this.lotOriginal.push(this.lotdetails[rs].lotNumber);
        let js: any;
        for (js in this.lotdetails) {
          if (this.lotdetails[js].lotNumber === this.lotdetails[rs].lotNumber && (this.lotdetails[js].lotStatus !== 'RA' &&
            this.lotdetails[js].lotStatus !== 'REA' && this.lotdetails[js].lotStatus !== 'AD')
            && this.lotdetails[js].id !== this.lotdetails[rs].id) {
            this.lotdetails[rs].originalBd = this.lotdetails[js].builderId;
            let ks: any;
            for (ks in this.lotsData) {
              if (this.lotsData[ks].lotNumber === this.lotdetails[rs].lotNumber) {
                this.lotsData[ks].originalBd = this.lotdetails[js].builderId;
                break;
              }
            }
          }
        }
      }
    }
    this.loadItems();
  }
  // disable lot buttons based on project number and grstatus
  public isProjectNumber() {
    const grTypes = ['SUBD', 'SCATT'];
    const grStatuses = ['APPDENIED', 'APPPEND', 'PEND', 'APPACCPT'];
    if ((this.projectNumber == null) || (grStatuses.includes(this.grStatus)) || (!grTypes.includes(this.grTypeCd))) {
      return true;
    } else {
      return false;
    }
  }
  // Kendo Grid page change event.
  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.loadItems();
  }
  // Apply site conact details to post to web api
  ApplySiteContact() {
    if (this.builderHomeForm.valid) {
      // array does not exist, is not an array, or is empty
      if (!Array.isArray(this.mySelection) || !this.mySelection.length) {
        this.SorryNotification();
      } else {
        this.addRequestService(this.builderHomeForm.value);
      }
    } else {
      triggerFormValidation(this.builderHomeForm);
      this.focusOnError(this.builderHomeForm);
    }
  }
  // Post data to Web Api
  private addRequestService(fg: LandingSiteContactDetails): void {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
    for (const lot in this.mySelection) {
     const  gridvalue: RequestServiceModel = this.lotsData.filter(a => a.lotNumber === this.mySelection[lot])[0];
      gridvalue.applicantContactName1 = fg.firstName;
      gridvalue.applicantContactName2 = fg.lastName;
      gridvalue.applicantPhoneNumber = phoneNumber(fg.contactNumber);
      gridvalue.applicantPhoneExtension = fg.contactNumberExtension;
      gridvalue.applicantEmail = fg.email;
      gridvalue.plannedDt = fg.plannedDate;
      gridvalue.otherDeliveryPressure = fg.other;
      if (gridvalue.lotStatus !== null && this.lookupSvc.LotStatusTypes !== undefined) {
        gridvalue.lotStatus = this.lookupSvc.LotStatusTypes.find(x => x.itemName === gridvalue.lotStatus).id;
      }
      gridvalue.deliveryPressure = fg.deliveryPressure['itemName'];
      if (fg.deliveryPressure['itemName'] === 'OTHER') {
      }
      this.rqstServiceLots.push(gridvalue);
    }
    this.builderSvc.PostServiceRequest(this.rqstServiceLots, this.rowValue).subscribe(result => {
      const wrTypeCodes = ['CINBE', 'RNBE', 'SRNBE', 'MLTFM'];
      this.rqstServiceLots = [];
      this.mySelection = [];
      this.selectAllState = 'unchecked';
      this.gridData3 = {
        data: [],
        total: 0
      };
      this.lotdetails = [];
      this.lotsData = [];
      this.lotOriginal = [];

      for (let i = 0; i < result.data.length; i++) {
        if (!wrTypeCodes.includes(result.data[i]['wrTypeCD'])) {
          result.data[i]['address'] = this.getLotServAddress(result.data[i]);
          const resultDate = result.data[i].constructionCompleteDate;
          if (resultDate !== null) {
            const resultday = new Date(resultDate);
            const resultdayTime = resultday.getTime();
            const dateDiff = Math.round((this.todayDate - resultdayTime) / this.one_day);
            if (dateDiff < 90) {
              if (result.data[i]['wrTypeCD'] != null) {
                const wrCd = {
                  oldwrCd: result.data[i]['wrTypeCD']
                };
                Object.assign(result.data[i], wrCd);
                result.data[i]['oldwrCd'] = (this.lookupSvc.WorkRequestType.find(x => x.id === result.data[i]['oldwrCd'])).itemName;
              }
              if (result.data[i]['lotStatus'] != null) {
                result.data[i]['lotStatus'] = (this.lookupSvc.LotStatusTypes.find(x => x.id === result.data[i]['lotStatus'])).itemName;
              }
              this.lotsData.push(result.data[i]);
            }
          } else {
              if (result.data[i]['wrTypeCD'] != null && result.data[i]['wrTypeCD'] != '') {
              const wrCd = {
                oldwrCd: result.data[i]['wrTypeCD']
              };
              Object.assign(result.data[i], wrCd);
              result.data[i]['oldwrCd'] = (this.lookupSvc.WorkRequestType.find(x => x.id === result.data[i]['oldwrCd'])).itemName;
            }
            if (result.data[i]['lotStatus'] != null) {
              result.data[i]['lotStatus'] = (this.lookupSvc.LotStatusTypes.find(x => x.id === result.data[i]['lotStatus'])).itemName;
            }
            this.lotsData.push(result.data[i]);
          }
        }
      }
      this.gridData3 = (process(this.lotsData, this.state));
      swal(this.constantsSvc.siteContactDetailsAppliedSwal, '', this.constantsSvc.successSwal);
      this.getDuplicates();
    },
    (error) => {
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.postRequestFail, this.constantsSvc.errorSwal);
    });
  }
// to show sorry notifications
  SorryNotification() {
    swal(this.constantsSvc.errorSwal1, this.constantsSvc.selectLotToAdd, this.constantsSvc.errorSwal);
  }
  // error focus on control
  focusOnError(form: any) {
    let control;
    Object.keys(form.controls)
      .reverse()
      .forEach(field => {
        if (form.get(field).invalid) {
          control = form.get(field);
          control.markAsDirty();
        }
      });

    if (control) {
      const el = $('.ng-invalid:not(form):first');
      $('html,body').animate(
        { scrollTop: el.offset().top - 40 },
        'slow',
        () => {
          el.focus();
        }
      );
    }
  }
  // Event to trigger pass input data to lot, request service, activate/deactivate
  showLot(lotNumber: any) {
    this.lotId = [];
    this.lotId.push(this.lotsData.filter(a => a.lotNumber === lotNumber)[0]);
    this.builderSvc.lotnum = lotNumber;
  }
  // Event to refresh the grid on changes in lot details pop up.
  refreshGrid(eve: any) {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
    this.lotsData = [];
    this.lotdetails = [];
    this.lotOriginal = [];
    this.gridData3 = {
      data: [],
      total: 0
    };
    if (this.serviceActivateRequestComponent) {
      this.serviceActivateRequestComponent.reset();
    }
    this.getServiceGridLotData();
    }
  // pass data to service new request component.
  showRequestService(lotNumber: any) {
    this.lotId = [];
    this.lotId.push(this.lotsData.filter(a => a.lotNumber === lotNumber)[0]);
  }
  // to disable Request Service if the status is not AA and RA
  disableRequestSer(rowdata: any): boolean {
    const temp = [];
    temp.push(rowdata.builderId);
    temp.push(rowdata.originalBd);
    this.parentList.forEach(element => {
      if (element.subsidiaryId === rowdata.builderId) {
        temp.push(element.id);
      }
    });
    if (this.lookupSvc !== undefined && this.lookupSvc.LotStatusTypes !== undefined) {
        const lotId = this.lookupSvc.LotStatusTypes.find(a => a.itemName === rowdata.lotStatus) !== undefined ?
        this.lookupSvc.LotStatusTypes.find(a => a.itemName === rowdata.lotStatus).id : rowdata.lotStatus;
      if ((lotId === 'AA' || lotId === 'RA') && this.isServiceRequested !== 'Y' && temp.includes(this.builderid) && rowdata.originalBd === this.builderid) {
        return false;
      }
    }
    return true;
  }
  // code to export grid data to excel
  public allData(): ExcelExportData {
    this.loading = true;
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
    this.result = {
       data: process(this.lotsData, { filter: this.state.filter }).data
   };
   this.loading = false;
   this.socoHttp.hidePleaseWait('ContainerAwaiter1');
 return this.result;
}
  // to disable activate deactive if the status is not SA, SR,  ACR, ACA, DR, DA
  disableActivate(rowdata: any): boolean {
    if (this.lookupSvc !== undefined && this.lookupSvc.LotStatusTypes !== undefined) {
      const lotId = this.lookupSvc.LotStatusTypes.find(a => a.itemName === rowdata.lotStatus) !== undefined ?
        this.lookupSvc.LotStatusTypes.find(a => a.itemName === rowdata.lotStatus).id : rowdata.lotStatus;
      if (this.stateCd === 'GA') {
        if (this.marketerDocCount !== 0 && (lotId === 'SA' || lotId === 'ACR' || lotId === 'ACA' || lotId === 'DR' || lotId === 'DA' || lotId === 'ACD' || lotId === 'DD')
            && rowdata.wrStatus === 'CLOSE' && rowdata.originalBd === this.builderid) {
          return false;
        }
      } else {
        if ((lotId === 'SA' || lotId === 'ACR' || lotId === 'ACA' || lotId === 'DR' || lotId === 'DA' || lotId === 'ACD' || lotId === 'DD')
            && rowdata.wrStatus === 'CLOSE' && rowdata.originalBd === this.builderid) {
                return false;
        }
        if ((lotId === 'SA' || lotId === 'ACR' || lotId === 'ACA' || lotId === 'DR' || lotId === 'DA' || lotId === 'ACD' || lotId === 'DD')
        && rowdata.wrStatus === 'CLOSE' && rowdata.originalBd === this.builderid) {
            return false;
        }
      }
    }
    return true;
  }
  // export to excel and pdf disable
  checkExport(): boolean {
    if (this.lotsData.length === 0) {
      return true;
    } else {
      return false;
    }
  }
  // create additional lots back button logic
  routeFlag() {
    this.navFlag = 's-rl';
    const substr: number = this.router.url.indexOf('builder') + 7;
    const str = this.router.url.slice(0, substr);
    this.router.navigate([str + '/' + 'lot/new' + '/' + this.rowValue + '/' + this.builderid + '/' + this.navFlag]);
  }
  // Lot Reassignment button logic
  reassignmentRoute() {
    this.navFlag = 's-blr';
    const substr: number = this.router.url.indexOf('builder') + 7;
    const str = this.router.url.slice(0, substr);
      this.router.navigate([str + '/' + 'requestlot' + '/' + this.rowValue + '/' + this.navFlag]);
 }
// Function to display other text box if user selected Others as  Delivery Pressure, and to hide the other text box
  // if user selected anything other than other.
  onStateChange(data: any) {
    if (data !== undefined && data['itemName'].toUpperCase() === 'OTHER') {
      this.builderHomeForm.controls['other'].setValidators(Validators.required);
      this.builderHomeForm.updateValueAndValidity();
    } else {
      this.builderHomeForm.controls['other'].clearValidators();
      this.builderHomeForm.controls['other'].reset();
      this.builderHomeForm.updateValueAndValidity();
    }
  }
// To format lot Address
  getLotServAddress(rowData1: any) {
    rowData1.streetNo = (rowData1.streetNo === null) ? '' : rowData1.streetNo ;
    rowData1.streetName = (rowData1.streetName === null) ? '' : rowData1.streetName;
    rowData1.city = (rowData1.city === null) ? '' : rowData1.city;
    rowData1.stateCd = (rowData1.stateCd === null) ? '' : rowData1.stateCd ;
    rowData1.zip = (rowData1.zip === null) ? '' : rowData1.zip;
    return rowData1.streetNo + ' ' + rowData1.streetName + ',' + rowData1.city + ',' +  rowData1.stateCd + ' ' + rowData1.zip + ', USA ';
  }
}
